/* Say The Label, slice 5b: the one behaviour the content pages need.
 *
 * A journal article's hero photo can carry round "+" pins, each opening a label that links to the
 * piece in the photo. On a mouse the label shows on hover, in CSS. On a touch screen there is no
 * hover, so a tap opens it; a tap on the label itself follows the link, and a tap anywhere else
 * closes whatever is open.
 *
 * A pin is a wrapper div holding a button and a link as siblings, so aria-expanded belongs to the
 * button, not to the wrapper the open class is written on.
 *
 * It is a standalone module: it imports nothing, shares no state, and does nothing at all on a
 * page with no pins. Everything else in this slice is Liquid, CSS and native <details>.
 */
(function () {
  var SEL = '.stl-art-hero';
  var ON = 'stl-is-on';

  function button(pin) {
    return pin.querySelector('.stl-pin-b');
  }

  function setOpen(pin, open) {
    pin.classList.toggle(ON, open);
    var b = button(pin);
    if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAll(root, except) {
    root.querySelectorAll('.stl-pin.' + ON).forEach(function (el) {
      if (el !== except) setOpen(el, false);
    });
  }

  function wire(hero) {
    if (hero.dataset.stlPinsReady === 'ready') return;
    hero.dataset.stlPinsReady = 'ready';

    hero.addEventListener('click', function (event) {
      var label = event.target.closest('.stl-pl');
      if (label) return; // the link wins
      var pin = event.target.closest('.stl-pin');
      if (!pin) return;
      event.preventDefault();
      var wasOn = pin.classList.contains(ON);
      closeAll(hero, pin);
      setOpen(pin, !wasOn);
    });

    hero.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!hero.querySelector('.stl-pin.' + ON)) return;
      var open = hero.querySelector('.stl-pin.' + ON);
      closeAll(hero);
      if (open && button(open)) button(open).focus();
    });
  }

  function start() {
    document.querySelectorAll(SEL).forEach(wire);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('.stl-pin')) return;
    document.querySelectorAll(SEL).forEach(function (hero) {
      closeAll(hero);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // the theme editor re-renders a section without reloading the page
  document.addEventListener('shopify:section:load', start);
})();
